import { isNaN } from 'lodash';

export const normalizeNumber = (value, previousValue) => {
  const withDots = value.replace(',', '.');
  if (isNaN(Number(withDots))) {
    return previousValue;
  }
  return withDots;
};
